import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { depListFn, orgInfoFn } from 'api/org/dep';
// import { listUrl } from 'api/org/per'

export default {
  data: function data() {
    return {
      visible: false,
      treeList: [],
      treeProps: {
        label: 'department_name',
        isLeaf: 'is_sub_department'
      },
      selectArr: []
    };
  },
  methods: {
    init: function init() {
      this.visible = true;
      this.getOrgInfo();
      this.selectArr = [];
    },
    getOrgInfo: function getOrgInfo() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.treeList = [];
              _context.next = 3;
              return orgInfoFn();
            case 3:
              res = _context.sent;
              if (res && res.code === 1) {
                _this.treeList.push({
                  is_sub_department: false,
                  department_name: res.data.department_name,
                  department_id: Number(res.data.id),
                  supervisor_id: res.data.supervisor_id,
                  supervisor_name: res.data.supervisor_name
                });
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    loadNode: function loadNode(node, resolve) {
      var _this2 = this;
      if (node.data.department_id) {
        depListFn({
          department_id: node.data.department_id
        }).then(function (res) {
          _this2.tableData = res.data;
          resolve(res.data.map(function (v) {
            return {
              department_name: v.department_name,
              department_id: Number(v.department_id),
              is_sub_department: !v.is_sub_department,
              supervisor_id: v.supervisor_id,
              supervisor_name: v.supervisor_name
            };
          }));
        });
      }
    },
    handleCheckChange: function handleCheckChange(val, _ref) {
      var checkedNodes = _ref.checkedNodes;
      this.selectArr = this.$refs.tree.getCheckedNodes();
    },
    handleCurrentChange: function handleCurrentChange(val, node) {},
    handleClose: function handleClose(item) {
      this.selectArr.splice(this.selectArr.indexOf(item), 1);
      this.$refs.tree.setChecked(item, false, true);
    },
    sure: function sure() {}
  }
};